import React from "react";
import { DropzoneArea } from "mui-file-dropzone";
import "./style.css";
import Table from "../tablas/view";
import { parseUblInvoice } from "../../../services/xmlParser";
import ButtonSecondary from "../../atoms/ButtonSecondary/view";

const formatCurrency = (value, currency = "COP") => {
  if (value === undefined || value === null || value === "") return "$0.00";
  const n = Number(String(value).replace(",", "").trim());
  if (Number.isNaN(n)) return String(value);
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
  }).format(n);
};

const XmlUploader = ({ handleData, invoiceData }) => {
  const handleFileUpload = (files) => {
    const file = files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const rawText = e.target.result;
        const invoice = parseUblInvoice(rawText);
        handleData(invoice);
      } catch (err) {
        console.error("Error parsing UBL XML:", err);
      }
    };
    reader.readAsText(file);
  };

  return (
    <div className="xml-uploader-container">
      {!invoiceData ? (
        <div className="dropzone-wrapper">
          <DropzoneArea
            acceptedFiles={[".xml"]}
            filesLimit={1}
            onDrop={(acceptedFiles) => handleFileUpload(acceptedFiles)}
            onDelete={() => handleData(null)}
            showFileNames={true}
            dropzoneText="Arrastra o haz clic para subir tu factura XML"
            showAlerts={['error']}
          />
        </div>
      ) : (
        <div className="invoice-summary-card">
          <div className="summary-header">
            <div className="title-group">
              <span className="label">Factura No.</span>
              <h3>{invoiceData.id || "---"}</h3>
            </div>
            <ButtonSecondary onClick={() => handleData(null)} title="Cambiar archivo" />
          </div>

          <div className="summary-grid">
            <div className="info-box">
              <span className="info-label">Proveedor</span>
              <p className="info-value">{invoiceData.supplier}</p>
              <span className="info-sub">{invoiceData.supplierNIT}</span>
            </div>
            <div className="info-box">
              <span className="info-label">Fecha Emisión</span>
              <p className="info-value">{invoiceData.issueDate}</p>
              <span className="info-sub">{invoiceData.issueTime}</span>
            </div>
          </div>

          <div className="items-preview-section">
            <span className="section-title">Detalle de productos ({(invoiceData.items || []).length})</span>
            <div className="mini-table-container">
              <Table
                data={invoiceData.items || []}
                maxHeight="300px"
                headersList={["Descripción", "Cant.", "Und.", "Precio", "Imp.", "Total"]}
                excludeList={["idx", "taxRate", "sku", "subtotal"]}
                formats={{
                  unit_price: { type: "money" },
                  tax: { type: "money" },
                  total: { type: "money" }
                }}
                allowSearch={false}
              />
            </div>
          </div>

          <div className="summary-footer">
            <div className="total-row">
              <span>Subtotal:</span>
              <span>{formatCurrency(invoiceData.subtotal, invoiceData.currency)}</span>
            </div>
            <div className="total-row">
              <span>Impuestos:</span>
              <span>{formatCurrency(invoiceData.tax, invoiceData.currency)}</span>
            </div>
            <div className="total-row main-total">
              <span>Total Factura:</span>
              <span>{formatCurrency(invoiceData.total, invoiceData.currency)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default XmlUploader;
